module.exports = __webpack_public_path__ + "assets/channel-manager.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/channel-manager.png
// module id = 1134
// module chunks = 7